import React, { useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Input, Button, Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { AuthWrapper } from './style';
import { login } from '../../../../ducks/auth';
import { getUser } from '../../../../ducks/user';
import * as ga from '../../../../utility/ga';

const LogInSchema = Yup.object().shape({
  email: Yup.string()
    .email()
    .required()
    .min(2)
    .max(50),
  password: Yup.string()
    .required()
    .min(2)
    .max(50),
});

const SignIn = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = (credentials, actions) => {
    dispatch(login(credentials)).then(() => {
      dispatch(getUser()).then(() => {
        actions.setSubmitting(false);
        import('react-facebook-pixel')
          .then(x => x.default)
          .then(ReactPixel => {
            ReactPixel.trackCustom('LOGGED', {
              name: `LOGGED`,
            });
          });
        ga.event('LOGGED', {
          event_label: 'LOGGED',
          event_category: 'LOGGED',
        });
        history.push(`/`);
      });
    });
  };

  useEffect(() => {
    import('react-facebook-pixel')
      .then(x => x.default)
      .then(ReactPixel => {
        ReactPixel.trackCustom('PLATFORM_LOGIN_FORM', {
          name: `PLATFORM_LOGIN_FORM`,
        });
      });
    ga.event('PLATFORM_LOGIN_FORM', {
      event_label: 'PLATFORM_LOGIN_FORM',
      event_category: 'PLATFORM_LOGIN_FORM',
    });
  }, []);

  return (
    <AuthWrapper>
      <div className="background-image" />
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validationSchema={LogInSchema}
        onSubmit={onSubmit}
      >
        {({ handleChange, handleBlur, handleSubmit, values, isValid, isSubmitting, errors, touched }) => (
          <div className="auth-container">
            <Col className="sign-in-main-col">
              <div className="auth-contents">
                <form>
                  <Col>
                    <div className="header-div">
                      <h2 className="sign-in-header-text">Zaloguj się na platformę</h2>
                    </div>
                    <Row xs={24} className="inputs-width">
                      <Col xs={24}>
                        <div className="input-label">
                          Adres e-mail
                          <div className="asterisk">* </div>
                        </div>
                        <Input
                          value={values.email}
                          autoComplete="kmi-email"
                          name="kmi-email"
                          onChange={handleChange('email')}
                          placeholder="kowalski@gmail.com"
                          onBlur={handleBlur('email')}
                          className="placeholder-italic-login-input"
                          id="email-input"
                        />
                        {errors.email && touched.email && (
                          <div className="login-email-error" style={{ paddingLeft: '5px' }}>
                            Sprawdź poprawność adresu e-mail
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row xs={24} className="inputs-width" id="sign-in-password-row">
                      <Col xs={24}>
                        <div className="input-label">
                          Hasło
                          <div className="asterisk">* </div>
                        </div>
                        <Input.Password
                          value={values.password}
                          autoComplete="kmi-password"
                          name="kmi-password"
                          onChange={handleChange('password')}
                          placeholder="Podaj hasło"
                          onBlur={handleBlur('password')}
                          className="placeholder-italic-password-input"
                          id="password-input-login"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Button
                        htmlType="submit"
                        type="primary"
                        className="button-loggin"
                        size="large"
                        onClick={handleSubmit}
                        disabled={!isValid || values.email === '' || values.password === ''}
                        loading={isSubmitting}
                      >
                        <b>ZALOGUJ</b>
                      </Button>
                    </Row>
                    <div className="link-div">
                      <NavLink to="/register" className="auth-link">
                        {'Dopiero zaczynasz naukę? '}
                        <b className="hover-text">Załóż swoje konto</b>
                      </NavLink>
                    </div>
                  </Col>
                </form>
              </div>
              <br />
            </Col>
          </div>
        )}
      </Formik>
    </AuthWrapper>
  );
};

export default SignIn;
